import React from 'react';
import '../../assets/css/icons.css';
import '../../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dropdown-tree-select/dist/styles.css';
import { SERVER_IP, PORT, PORT_webRTC } from '../../Server';
import RTCMultiConnection from 'rtcmulticonnection-react-js';

var connection = "";
// var connection = new RTCMultiConnection();
class VideoConf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Room_Id: ""
    }
  }
  componentDidMount() {
    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }
    // Let's check whether notification permissions have already been granted
    //else if (Notification.permission === "granted") {

    // var notification = new Notification("Hi there!");
    // If it's okay let's create a notification
    //}
    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
      Notification.requestPermission(function (permission) {
        // If the user accepts, let's create a notification
        // if (permission === "granted") {
        // }
      });
    }
    // At last, if the user has denied notifications, and you 
    // want to be respectful there is no need to bother them any more.

    // alert("running")
    // this line is VERY_important
    connection.socketURL = "https://api.assist.simulanis.iom:49445/testshared";
 
    // all below lines are optional; however recommended.
    connection.session = {
      audio: true,
      video: true,
      // data: true,
      //screen: true,
      //oneway: true
    };

    connection.sdpConstraints.mandatory = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true
    };

    // STAR_FIX_VIDEO_AUTO_PAUSE_ISSUES
    // via: https://github.com/muaz-khan/RTCMultiConnection/issues/778#issuecomment-524853468
    var bitrates = 512;
    var resolutions = 'Ultra-HD';
    var videoConstraints = {};

    if (resolutions == 'HD') {
      videoConstraints = {
        width: {
          ideal: 200
        },
        height: {
          ideal: 200
        },
        frameRate: 30
      };
    }

    if (resolutions == 'Ultra-HD') {
      videoConstraints = {
        width: {
          ideal: 300
        },
        height: {
          ideal: 300
        },
        frameRate: 30
      };
    }

    connection.mediaConstraints = {
      video: videoConstraints,
      audio: true
    };

    var CodecsHandler = connection.CodecsHandler;

    connection.processSdp = function (sdp) {
      var codecs = 'vp8';

      if (codecs.length) {
        sdp = CodecsHandler.preferCodec(sdp, codecs.toLowerCase());
      }

      if (resolutions == 'HD') {
        sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
          audio: 128,
          video: bitrates,
          screen: bitrates
        });

        sdp = CodecsHandler.setVideoBitrates(sdp, {
          min: bitrates * 8 * 1024,
          max: bitrates * 8 * 1024,
        });
      }

      if (resolutions == 'Ultra-HD') {
        sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
          audio: 128,
          video: bitrates,
          screen: bitrates
        });

        sdp = CodecsHandler.setVideoBitrates(sdp, {
          min: bitrates * 8 * 1024,
          max: bitrates * 8 * 1024,
        });
      }

      return sdp;
    };
    // END_FIX_VIDEO_AUTO_PAUSE_ISSUES

    // https://www.rtcmulticonnection.org/docs/iceServers/
    // use your own TURN-server here!
    // connection.iceServers = [{
    //   'urls': [
    //     'stun:stun.l.google.com:19302',
    //     'stun:stun1.l.google.com:19302',
    //     'stun:stun2.l.google.com:19302',
    //     'stun:stun.l.google.com:19302?transport=udp',
    //   ]
    // }];
    // first step, ignore default STUN+TURN servers
    connection.iceServers = [];

    // second step, set STUN url
    connection.iceServers.push({
      urls: 'stun:stun.simulanis.co.in:5349'
    });

    // last step, set TURN url (recommended)
    connection.iceServers.push({
      urls: 'turn:turn.simulanis.co.in:5349',
      credential: ' XU9QRE[GVp9aPDjDwA6',
      username: 'turnuser'
    });

    connection.videosContainer = document.getElementById('videos-container');
    connection.onstream = function (event) {
      var existing = document.getElementById(event.streamid);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }

      event.mediaElement.removeAttribute('src');
      event.mediaElement.removeAttribute('srcObject');
      event.mediaElement.muted = true;
      event.mediaElement.volume = 0;

      var video = document.createElement('video');

      try {
        video.setAttributeNode(document.createAttribute('autoplay'));
        video.setAttributeNode(document.createAttribute('playsinline'));
      } catch (e) {
        video.setAttribute('autoplay', true);
        video.setAttribute('playsinline', true);
      }

      if (event.type === 'local') {
        video.volume = 0;
        try {
          video.setAttributeNode(document.createAttribute('muted'));
        } catch (e) {
          video.setAttribute('muted', true);
        }
      }
      video.srcObject = event.stream;

      var width = parseInt(connection.videosContainer.clientWidth / 3) - 20;
      var mediaElement = video;
      // var mediaElement = getHTMLMediaElement.getHTMLMediaElement(video, {
      //     title: event.userid,
      //     buttons: ['full-screen'],
      //     width: width,
      //     showOnMouseEnter: false
      // });

      connection.videosContainer.appendChild(mediaElement);

      setTimeout(function () {
        mediaElement.play();
      }, 5000);

      mediaElement.id = event.streamid;

      // to keep room-id in cache
      localStorage.setItem(connection.socketMessageEvent, connection.sessionid);

      // chkRecordConference.parentNode.style.display = 'none';

      // if(chkRecordConference.checked === true) {
      //   btnStopRecording.style.display = 'inline-block';
      //   recordingStatus.style.display = 'inline-block';

      //   var recorder = connection.recorder;
      //   if(!recorder) {
      //     recorder = RecordRTC([event.stream], {
      //       type: 'video'
      //     });
      //     recorder.startRecording();
      //     connection.recorder = recorder;
      //   }
      //   else {
      //     recorder.getInternalRecorder().addStreams([event.stream]);
      //   }

      //   if(!connection.recorder.streams) {
      //     connection.recorder.streams = [];
      //   }

      //   connection.recorder.streams.push(event.stream);
      //   recordingStatus.innerHTML = 'Recording ' + connection.recorder.streams.length + ' streams';
      // }

      if (event.type === 'local') {
        connection.socket.on('disconnect', function () {
          if (!connection.getAllParticipants().length) {
            window.location.reload();
          }
        });
      }
    };

    // var recordingStatus = document.getElementById('recording-status');
    // var chkRecordConference = document.getElementById('record-entire-conference');
    // var btnStopRecording = document.getElementById('btn-stop-recording');
    // btnStopRecording.onclick = function() {
    // var recorder = connection.recorder;
    // if(!recorder) return alert('No recorder found.');
    // recorder.stopRecording(function() {
    //   var blob = recorder.getBlob();
    //   invokeSaveAsDialog(blob);

    //   connection.recorder = null;
    //   btnStopRecording.style.display = 'none';
    //   recordingStatus.style.display = 'none';
    //   chkRecordConference.parentNode.style.display = 'inline-block';
    // });
    // };

    connection.onstreamended = function (event) {
      var mediaElement = document.getElementById(event.streamid);
      if (mediaElement) {
        mediaElement.parentNode.removeChild(mediaElement);
      }
    };

    connection.onMediaError = function (e) {
      // if (e.message === 'Concurrent mic process limit.') {
      //     if (DetectRTC.audioInputDevices.length <= 1) {
      //         alert('Please select external microphone. Check github issue number 483.');
      //         return;
      //     }

      //     var secondaryMic = DetectRTC.audioInputDevices[1].deviceId;
      //     connection.mediaConstraints.audio = {
      //         deviceId: secondaryMic
      //     };

      //     connection.join(connection.sessionid);
      // }
    };


  }
  joinRoom = () => {
    connection.join(this.state.Room_Id, function (isJoinedRoom, roomid, error) {
      if (error) {
        // disableInputButtons(true);
        if (error === 'Room not available') {
          alert('This room does not exist. Please either create it or wait for moderator to enter in the room.');
          return;
        }
        alert(error);
      }

    });
  }

  openRoom = () => {
    var _this = this;
    connection.open(this.state.Room_Id, function (isRoomOpened, roomid, error) {
      if (isRoomOpened === true) {
        _this.showRoomURL(connection.sessionid);
      }
      else {
        // disableInputButtons(true);
        if (error === 'Room not available') {
          alert('Someone already created this room. Please either join or create a separate room.');
          return;
        }
        alert(error);
      }
    });
  }
  
  showRoomURL = (roomid) => {
    var roomHashURL = '#' + roomid;
    var roomQueryStringURL = '?roomid=' + roomid;

    var html = '<h2>Unique URL for your room:</h2><br>';

    html += 'Hash URL: <a href="' + roomHashURL + '" target="_blank">' + roomHashURL + '</a>';
    html += '<br>';
    html += 'QueryString URL: <a href="' + roomQueryStringURL + '" target="_blank">' + roomQueryStringURL + '</a>';

    var roomURLsDiv = document.getElementById('room-urls');
    roomURLsDiv.innerHTML = html;

    roomURLsDiv.style.display = 'block';
  }
  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  render() {

    return (
      <div style={{ background: "#2c2d4e", height: "98vh" }}>
        <div className="extraSpace">
        </div>


        <h1>
          Video Conferencing using RTCMultiConnection
          <p class="no-mobile">
          Multi-user (many-to-many) video chat using mesh networking model.
          </p>
        </h1>

        <section class="make-center">
          <div>
            <div class="container cont-vdo-center">
              <div class="row">
                <div class="col-sm-6">

                  <div class="form-group row">
                    {/* <label for="colFormLabelLg" class="col-sm-2 col-form-label col-form-label-lg"></label> */}
                    <div class="col-sm-10">
                      <input type="text" id="room-id" onChange={this.onChangeInput} name="Room_Id" value={this.state.Room_Id} class="form-control form-control-lg" placeholder="Enter Meeting ID" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">

                  <button id="open-room" className="btn btn-outline-success" onClick={this.openRoom}>Create New Meeting</button>
                  <button id="join-room" className="btn btn-outline-warning mt-3" onClick={this.joinRoom}>Join Meeting</button>

                </div>

              </div>

            </div>
          </div>
          <div id="videos-container" style={{ margin: "20px 0" }}></div>
          <div id="room-urls" style={{ textAlign: "center", display: "none", background: "#F1EDED", margin: "15px -10px", border: "1px solid rgb(189, 189, 189)", borderLeft: "0", borderRight: "0" }}></div>
        </section>
      </div>
    );
  }
}

export default VideoConf;